import { render, staticRenderFns } from "./Impersonate.vue?vue&type=template&id=e89f2372&"
import script from "./Impersonate.vue?vue&type=script&lang=ts&"
export * from "./Impersonate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports